<template>
	<div class="videoMark" v-if="$store.state.videoType">
		<span class="close" @click="closeVideo">×</span>
		<video id="myVideos" class="video-js" ref='videoRef'>
			<source :src="$store.state.videoList[$store.state.videoId-1]" type="video/mp4">
		</video>
		<p v-if="getPlay"></p>
	</div>
</template>
<script>
	export default {
	    data(){
		    return{
				videoList:[
				    // require('@/assets/video/0.mp4'),
                    // require('@/assets/video/1.mp4'),
                    // require('@/assets/video/2.mp4'),
                    // require('@/assets/video/3.mp4'),
                    // require('@/assets/video/4.mp4'),
                    // require('@/assets/video/5.mp4'),
				]
		    }
	    },
	    computed:{
	        getPlay(){
	            if(this.$store.state.videoType){
	              var that = this;
	              setTimeout(function () {
                    that.initVideo()
                  },500)
	            }
	        }
	    },
	    methods:{
            initVideo() {
	            // 初始化视频方法
	            let myPlayer = this.$video(myVideos, {
	              // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
	              controls: true,
	              // 自动播放属性,muted:静音播放
	              autoplay: "autoplay",
	              loop: true,
	              // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
	              preload: "auto",
	              // 设置视频播放器的显示宽度（以像素为单位）
	              width: '1244px',
	              // 设置视频播放器的显示高度（以像素为单位）
	              height: "700px"
	            })
            },
            closeVideo(){
                this.$store.commit({
	                type: 'setVideoPlay',
	                videoType: false,
	                videoId: -1
                })
            }
	    },
	    mounted () {

        }
    }
</script>
<style scoped>
	.videoMark{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 11;
		background: rgba(0,0,0,.8);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.close{
		color: #fff;
		font-size: 40px;
		position: absolute;
		top: 50%;
		right: 30px;
		margin-top: -420px;
		cursor: pointer;
	}
	@media (max-width: 1600px) {
		.myVideos-dimensions {
			width: 100% !important;
			height: 400px;
		}
		.close{
			margin-top: -260px;
		}
	}
	@media (max-width: 960px) {
		.myVideos-dimensions {
			width: 100% !important;
			height: 300px;
		}
		.close{
			top: 50%;
			right: 10px;
			font-size: 25px;
			margin-top: -190px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/videoPlay/videoPlay.vue